module.exports = __webpack_public_path__ + "load-ninja.2W8YEiPV.svg";